<template>
  <div>
    <div class="header">
      <title-vue title="Lista de franquias" />
      <v-btn dark color="#e5183d" @click="handleNewFranchise()"
        >Nova franquia</v-btn
      >
    </div>
    <v-skeleton-loader
      v-if="!!loading"
      tile
      loading
      class="mx-auto"
      type="card"
      elevation="{5}"
      boilerplate
    />
    <v-card v-else>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquise pela cidade, estado, nome do responsável ou telefone do responsável"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :header-props="{ sortByText: 'Filtrar por' }"
        :headers="headers"
        :items="franchises"
        :items-per-page="10"
        :footer-props="{ 'items-per-page-text': 'franquias por página' }"
        :search="search"
        no-data-text="Nenhuma franquia encontrada"
        class="elevation-0"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="d-block d-sm-table-cell">{{ item.cityName }}</td>
              <td class="d-block d-sm-table-cell">{{ item.state }}</td>
              <td class="d-block d-sm-table-cell">
                {{ item.franchiseAdmins[0].name }}
              </td>
              <td class="d-block d-sm-table-cell">
                {{ phoneNumberFormat(item.franchiseAdmins[0].phone) }}
              </td>
              <td class="d-block d-sm-table-cell">
                <v-icon
                  size="24"
                  color="#e5183d"
                  @click="handleDetailFranchise(item.id)"
                  >mdi-menu</v-icon
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TitleVue from "@/components/title/Title.vue";

import { FranchiseType } from "@/types/franchise/Franchise";
import { GetAllFranchises } from "@/services/franchises/GetAllFranchises";
import { format } from "date-fns";

interface SortItem {
  name: string;
  phone: string;
  createdAt: string;
}

export default defineComponent({
  components: { TitleVue },

  data() {
    return {
      mobileBreakpoint: 600,
      loading: true,
      showModal: false,
      showModalRemove: false,

      franchises: [] as FranchiseType[],
      search: "",
      sortBy: [] as ReadonlyArray<SortItem>,
      sortDesc: false,
      noDataText: "Nenhum dado disponível",
      headers: [
        {
          text: "Cidade",
          value: "cityName",
        },
        { text: "Estado", value: "state" },
        { text: "Responsável", value: "primaryFranchisee.name" },
        { text: "Telefone do responsável", value: "primaryFranchisee.phone" },
        {
          text: "Ações",
          value: "actions",
        },
      ],
    };
  },
  methods: {
    async handleLoadFranchises() {
      this.loading = true;
      const getAllFranchises = new GetAllFranchises();
      const franchises = await getAllFranchises.execute();
      console.log(franchises);
      this.franchises = franchises;
      this.loading = false;
    },
    handleNewFranchise() {
      this.$router.push({
        name: "franchiseForm",
        params: { modeForm: "new" },
      });
    },
    handleDetailFranchise(id: string) {
      this.$router.push(`/franchise/form/${id}`);
    },
    phoneNumberFormat: (value: string): string => {
      if (!value) return "";
      const phone =
        "(" +
        value.substr(0, 2) +
        ") " +
        value.substr(2, 5) +
        "-" +
        value.substr(7, 8);
      return phone;
    },
    formatDate: (date: string): string => {
      const dateFormated = format(new Date(date), "dd/MM/yyyy HH:mm:ss");
      return dateFormated;
    },
  },
  mounted() {
    this.handleLoadFranchises();
  },
});
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
